

import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
}

function PolicyFooter({ color }: Props): ReactElement {

    return (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill={color ? color : ""} d="M17.9985 10.4996L12.9985 10.4996" stroke={color ? color : "#155a9e"} strokeWidth="1.5" strokeLinecap="round"/>
<path d="M9.99854 3.5H16.4985C16.963 3.5 17.1952 3.5 17.3901 3.52567C18.7363 3.7029 19.7956 4.76222 19.9729 6.10842C19.9985 6.30337 19.9985 6.53558 19.9985 7" stroke={color ? color : "#155a9e"} strokeWidth="1.5"/>
<path fill={color ? color : ""} d="M2.00146 7.45011C2.00146 6.56758 2.00146 6.12632 2.07081 5.75875C2.37611 4.14067 3.64177 2.87501 5.25985 2.56972C5.62742 2.50037 6.06868 2.50037 6.95121 2.50037C7.33789 2.50037 7.53123 2.50037 7.71704 2.51774C8.51812 2.59265 9.27799 2.9074 9.89741 3.42088C10.0411 3.53998 10.1778 3.67669 10.4512 3.95011L11.0015 4.50037C11.8172 5.31615 12.2251 5.72404 12.7136 5.99579C12.9819 6.14508 13.2665 6.26297 13.5618 6.34714C14.0994 6.50037 14.6762 6.50037 15.8299 6.50037H16.2036C18.8359 6.50037 20.1521 6.50037 21.0076 7.26983C21.0863 7.34061 21.1612 7.4155 21.232 7.4942C22.0015 8.34972 22.0015 9.6659 22.0015 12.2983V14.5004C22.0015 18.2716 22.0015 20.1572 20.8299 21.3288C19.6583 22.5004 17.7727 22.5004 14.0015 22.5004H10.0015C6.23023 22.5004 4.34461 22.5004 3.17304 21.3288C2.00146 20.1572 2.00146 18.2716 2.00146 14.5004V7.45011Z" stroke={color ? color : "#424242"} strokeWidth="1.5"/>
</svg>
    );
}

export default PolicyFooter;